import { render, staticRenderFns } from "./ProgramsContent.vue?vue&type=template&id=450ff208&scoped=true&"
import script from "./ProgramsContent.vue?vue&type=script&lang=js&"
export * from "./ProgramsContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450ff208",
  null
  
)

export default component.exports